import { atom } from "recoil";

export const uniMsgAtom = atom({
  key: "uni_msg",
  default: null,
});
